import Vue from 'vue'
import Router from 'vue-router'
import stuCasLogin from '@/components/stuCasLogin'
import menhuCasLogin from '@/components/menhuCasLogin'
import adminCasLogin from '@/components/adminCasLogin'
import index from '@/components/index'
import tieZi from '@/components/tieZi'
import more from '@/components/more'
import login from '@/components/login'
import adminIndex from '@/components/adminIndex'
import myTZ from '@/components/myTZ'
import detail from '@/components/detail'
import infoDetail from '@/components/infoDetail'
import adminDetail from '@/components/adminDetail'
import ComplaintsAndSuggestionsList from '@/components/pc/ComplaintsAndSuggestionsList'
import ComplaintsAndSuggestionsForm from '@/components/pc/ComplaintsAndSuggestionsForm'
import mine from '@/components/pc/mine'
import PCLogin from '@/components/pc/PCLogin'
import ComplaintsAndSuggestionsDetail from '@/components/pc/ComplaintsAndSuggestionsDetail'
import ComplaintsAndSuggestionsMyDetail from '@/components/pc/ComplaintsAndSuggestionsMyDetail'
import News from '@/components/pc/News'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      meta: {
        isLogin: false
      },
      component: index
    },

    {
      path: '/pc',
      name: 'ComplaintsAndSuggestionsList',
      component: ComplaintsAndSuggestionsList,
      meta:{
        title:'首页',
        keepAlive: true,
        isUseCache: false
      }
    },
    //pc端发帖
    {
      path: '/casForm',
      name: 'ComplaintsAndSuggestionsForm',
      component: ComplaintsAndSuggestionsForm
    },
    {
      path: '/mine',
      name: 'mine',
      component: mine
    },
    {
      path: '/casDetail',
      name: 'ComplaintsAndSuggestionsDetail',
      component: ComplaintsAndSuggestionsDetail
    },
    {
      path: '/casMyDetail',
      name: 'ComplaintsAndSuggestionsMyDetail',
      component: ComplaintsAndSuggestionsMyDetail
    },
    //pc端登录
    {
      path: '/PCLogin',
      name: 'PCLogin',
      meta: {
        isLogin: false
      },
      component: PCLogin
    },
    {
      path: '/news',
      name: 'News',
      component: News
    },
    {
      path: '/logonSSO',
      name: 'index',
      meta: {
        isLogin: false
      },
      component: index
    },

  {
      path: '/stuCasLogin',
      name: 'StuCasLogin',
      component: stuCasLogin
    },
    {
      path: '/menhuCasLogin',
      name: 'MenhuCasLogin',
      component: menhuCasLogin
    },

    {
      path: '/adminCasLogin',
      name: 'AdminCasLogin',
      component: adminCasLogin
    },
    {
      path: '/tieZi',
      name: 'tieZi',
      meta: {
        isLogin: true
      },
      component: tieZi

    },
    {
      path: '/more',
      name: 'more',
      meta: {
        isLogin: false
      },
      component: more
    },


    {
      path: '/login',
      name: 'login',
      meta: {
        isLogin: false
      },
      component: login
    },


    {
      path: '/adminIndex',
      name: 'adminIndex',
      meta: {
        isLogin: false
      },
      component: adminIndex
    },
    {
      path: '/myTZ',
      name: 'myTZ',
      meta: {
        isLogin: true  // 是否需要判断是否登录,这里是需要判断
      },
      component: myTZ
    },
    {
      path: '/detail',
      name: 'detail',
      meta: {
        isLogin: false
      },
      component: detail
    },
    {
      path: '/infoDetail',
      name: 'infoDetail',
      meta: {
        isLogin: false
      },
      component: infoDetail
    },
    {
      path: '/adminDetail',
      name: 'adminDetail',
      meta: {
        isLogin: false
      },
      component: adminDetail
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js